module.exports = __webpack_public_path__ + "static/img/banner.2ed6f74.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/banner.jpg
 ** module id = 51
 ** module chunks = 1
 **/